export default __webpack_public_path__ + "static/media/cartorio2.0872957b.png";